import { Limited, LimitEnable, LimitMode, LimitStatus } from '@EcamModel/model/PTZLimit';
import { Divider, Stack, Typography } from '@mui/material';
import { useCameraDetailContext } from '@pages/cameras/hook/CameraDetailsProvider';
import { DataSectionHasSubItem, SectionHasSubItemHeader, SectionNotSubItemStatus } from './BasicInfoMilesightCameraPTZ';
import { useEffect } from 'react';

const ptzLimitModeMapping: { [key in LimitMode]: string } = {
    [LimitMode.Manual]: 'Manual Limit',
    [LimitMode.Scan]: 'Scan Limit',
};

const enablePTZLimitMapping: { [key in LimitEnable]: string } = {
    [LimitEnable.No]: 'No',
    [LimitEnable.Yes]: 'Yes',
};

const manualLimitStatusMapping: { [key in LimitStatus]: string } = {
    [LimitStatus.NotLimited]: 'Not Limited',
    [LimitStatus.Limited]: 'Limited',
};

const manualLimitedMapping: { [key in Limited]: string } = {
    [Limited.EnableLeft]: 'Enable Left',
    [Limited.EnableRight]: 'Enable Right',
    [Limited.EnableDown]: 'Enable Down',
    [Limited.EnableUp]: 'Enable Up',
};

export default function PTZ_LimitsMilesightsCameraPTZ() {
    const handleEdit = () => {
        console.log('Edit button clicked');
    };

    const { camera } = useCameraDetailContext();

    const PTZLimit = camera?.PTZCamera?.PTZCameraConfig?.Limit;

    const statusList_PTZlimits: DataSectionHasSubItem[] = [
        {
            label: 'Limit mode:',
            value: <Typography>{ptzLimitModeMapping[PTZLimit?.Mode!]}</Typography>,
        },
        {
            label: 'Mod status:',
            value: (
                <Typography>
                    {manualLimitStatusMapping[PTZLimit?.ManualLimitStatus! ?? PTZLimit?.ScanLimitStatus!]}
                </Typography>
            ),
        },
        {
            label: 'Enable:',
            value: (
                <Typography>
                    {enablePTZLimitMapping[PTZLimit?.ManualLimitEnable! ?? PTZLimit?.ScanLimitEnable!]}
                </Typography>
            ),
        },
    ];

    return (
        <Stack id="PTZ_limits" border={'1px solid #E4E7EC'} borderRadius={2} flex={1}>
            {/* PTZ Limits Information */}
            <SectionHasSubItemHeader id="" title="PTZ Limits" onEdit={handleEdit} />

            <Divider
                orientation="vertical"
                sx={{
                    borderBottomWidth: 1,
                    borderColor: '#E4E7EC',
                    mx: 2,
                }}
            />

            <Stack spacing={2} padding={2} borderRadius={1} margin={1}>
                {statusList_PTZlimits.map((status, index) => (
                    <SectionNotSubItemStatus key={index} label={status.label} value={status.value} />
                ))}
            </Stack>
        </Stack>
    );
}
